import styled from '@emotion/styled';

export const Wrapper = styled.div<{ isActive: boolean }>`
  height: 43px;
  min-width: 43px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.grey300 : '#fff'};

  border-radius: ${({ isActive }) => (isActive ? '32px' : '4px')};
  padding: ${({ isActive }) => (isActive ? '0 16px' : '0')};
  cursor: pointer;
`;

export const BtnTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primaryBlue};
`;
